// extracted by mini-css-extract-plugin
export var messageSideLeft = "_oi-1";
export var messageSideRight = "_oi-2";
export var subscribeToBackInStockBubbleContainer = "_oi-0";